export const types = {
  CHANGE_POSTS: 'CHANGE_POSTS',
};

export const changePosts = posts => ({
  type: types.CHANGE_POSTS,
  payload: {
    posts,
  },
});

const initialState = {
  posts: [],
  page: 1,
  limit: 5,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_POSTS:
      return {
        ...state,
        posts: action.payload.posts,
      };
    default:
      return state;
  }
};

export default reducer;

export const getPagePosts = state => state.pagePost.posts;



// WEBPACK FOOTER //
// ./app/redux/pagePost.js